import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import './App.scss';
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import shoebyLogo from './assets/images/Shoeby_NEW_logo.png'
// PrimeReact
import "primereact/resources/themes/lara-dark-blue/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
// Components
import { Error } from './components/Error/Error';
import { ToastContainer } from "react-toastify";
import FullscreenSpinner from './components/GeneralComponents/Spinner/FullscreenSpinner';
import Home from './components/Home/Home';
import CharlyChat from './components/Charly/CharlyChat';
// Functions
import config from './config';
import storage from './common/storage';
// Hooks
import useGetUserAuth from './hooks/useGetUserAuth';
import { useKeycloak } from "@react-keycloak/web";
import useGetUserId from './hooks/useGetUserId';
import { resetApplication } from './common/applicationCache';
import hasProps from './common/hasProps';
import useApiError from './hooks/useApiError';

export const MainContext = React.createContext();

function App() {
  const { keycloak } = useKeycloak();
  const userName = keycloak?.tokenParsed?.name;
  const userLogout = keycloak?.logout; 
  const { error } = useApiError(); 

  // Clear storage after user accepts an update.
  useEffect(() => {
    const reloadLocalstorage = localStorage.getItem("reload-localstorage");
    if (reloadLocalstorage && JSON.parse(reloadLocalstorage) === true) {
      localStorage.clear();
    }
  }, []);

  let [userEmail, setUserEmail] = useState("");
  let userIsAuth = useGetUserAuth(userEmail);
  let userId = useGetUserId(userEmail);

  useEffect(()=> { 
    if(keycloak?.tokenParsed?.email) {
        setUserEmail(keycloak?.tokenParsed?.email);
    }
  }, [keycloak?.tokenParsed?.email]);

  let [amountPerPage, setAmountPerPage] = useState(storage.get("Chatbot_AmountPerPage") ?? config.app.amountPerPage);

  return (
    <>
      <ToastContainer limit={6} />
      {userIsAuth.exists === null && userIsAuth.isBlocked === null && userIsAuth.code === 200 && !hasProps(error) &&
        <>
          <FullscreenSpinner displayText="Authenticating..." />
        </>
      }
      {userIsAuth && userIsAuth.isBlocked === false &&
        <Router>
          <header className={`sticky ${config.app.environmentClass}`}>
            <nav>
              <div className="d-flex align-items-center justify-content-between p-2 bg--primary">
                <div className="d-flex align-items-center gap-4">
                  <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/"><h5 className="text-white m-0">
                    <img src={shoebyLogo} alt="Shoeby" className='logo-height'/></h5>
                  </NavLink>
                  <NavLink className="nav-link" activeClassName="active" aria-current="page" to="/charly"><h5 className="text-white m-0">Charly</h5></NavLink>
                </div>

                <div className="nav-item dropdown">
                  <a href="/#" className="nav-link dropdown-toggle text-white d-flex align-items-center" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                    <span className="d-none d-sm-inline">{userName}</span>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <li><a href="/#" className="dropdown-item" onClick={userLogout}>Logout</a></li>
                  </ul>
                </div>
              </div>
            </nav>
          </header>
          <main className="container-fluid">
            <MainContext.Provider value={{
                userEmail, setUserEmail,
                amountPerPage, setAmountPerPage,
                userId
            }}>
              <Switch>
                <Route path="/home"                       render={(props) => ( <Home {...props} userName={userName} /> )}/>
                <Route path="/charly"                     component={CharlyChat}/>
                <Route path="/"                           render={(props) => ( <Home {...props} userName={userName} /> )}/>
              </Switch>
            </MainContext.Provider>
          </main>
        </Router>
      }
      {((userIsAuth.exists && userIsAuth.isBlocked) || userIsAuth.exists === false) && <>
        <header className={config.app.environmentClass}>
          <nav className="navbar navbar-dark bg--primary navbar-expand-md navbar-toggleable-md ng-white border-bottom box-shadow mb-3">
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#ChatbotMenu" aria-controls="ChatbotMenu" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="ChatbotMenu">
                  <ul className="navbar-nav mb-2 mb-lg-0">
                      <li className="nav-item">
                        <span className="nav-link disable" aria-current="page" to="/home">Chatbot App</span>
                      </li>
                  </ul>
              </div>
          </nav>
        </header>
        <main className="container-fluid">
          <h6 className="alert alert-danger">{userIsAuth.code} - Sorry, je hebt geen toegang tot de Chatbot App.</h6>
        </main>
      </>}
      {hasProps(error) && (
        <Error />
      )}
      <footer>
        <p>v{config.app.version} &emsp; &copy; {new Date().getFullYear()} Shoeby - AI Team | <span className="reset-app" onClick={() => resetApplication("ChatbotCache")}>Reset app</span></p>
      </footer>
    </>
  );
}

export default App;